<template>
  <!-- :disabled="!isEditMode" -->
  <div
    v-if="train.closed && taktarea_index === 0 || !train.closed"
    class="m-taktarea-intersection-placeholder"
    v-intersect="onintersect"
    :style="`
      width: calc((${getProjectLength(project_id) + 2} * (var(--workpackage_width) + 8px) + var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px) * var(--taktplan_zoom));
      `"
    >
    <transition
      name="grow-y"
      >
      <TaktArea
        v-if="show_taktarea && (train.closed && taktarea_index === 0 || !train.closed)"
        :id="`taktarea${taktarea.id}`"
        :ref="`taktarea${taktarea.id}`"
        :key="`taktarea${taktarea.id}`"
        :project_length="getProjectLength(project_id)"
        header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
        >
        <template #taktarea>
          <!-- Takt time Highlighter -->
          <TaktTimeHighLighter
            v-if="getCurrentTaktIndex(project_id) !== false"
            :index="isSpatialView ? Math.abs(getCurrentTaktIndex(project_id)) : Math.abs(getCurrentTaktIndex(project_id)) + 1"
            header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
            z_index="2"
            />
          <TaktTimeHighLighter
            v-if="getCurrentTaktIndex(project_id) !== false &&
                  getCurrentTaktIndex(project_id) >= 0"
            :index="isSpatialView ? getCurrentTaktIndex(project_id) + 1 : getCurrentTaktIndex(project_id) + 2"
            header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
            z_index="2"
            />
          <template v-if="!train.closed">
            <HeaderTrainOpen
              v-if="taktarea_index === 0"
              :taktarea_count="train.closed?1:train.taktareas.length"
              @click.native="
                toggleWaggonTransition(),
                updateUDObject({
                  url: [
                    {projects: project_id},
                    {trains: train.id},
                  ],
                  update: {
                    closed: !train.closed
                  }
                })"
              >
              <div>{{train.name}}</div>
            </HeaderTrainOpen>
            <div v-else style="width: calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"/>
          </template>
          <HeaderRow
            v-if="train.closed"
            z_index="6"
            width="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            sticky_left="0px"
            :key="`trainname${train.id}`"
            :border_color="getHeaderRowBorder('trains', train, new_milestone, 'black')"
            :color="train.closed?'grey darken-1':''"
            :text="train.closed? train.name:taktarea.name"
            :readonly="isEditMode && $route.name === 'ProjectTaktPlan'? false:true"
            @click.native="
              isEditMode?
              handleHeaderRowClick(train, taktarea)
              :
              updateUDObject({
                url: [
                  {projects: project_id},
                  {trains: train.id}
                ],
                update: {
                  closed: false
                }
              })"
            >
            <template #middle-left>
              </template>
            <template #top-center>
            </template>
            <template #bottom-center>
            </template>
          </HeaderRow>
          <!-- taktarea header -->

          <HeaderRow
            v-if="!train.closed"
            z_index="6"
            sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
            :key="`taktareaname${taktarea.id}`"
            :border_color="getHeaderRowBorder('taktareas', taktarea, new_milestone, '#424242')"

            inner_border="solid 1px rgba(255,255,255,0.8)"
            :text="taktarea.name"
            :readonly="isEditMode && $route.name === 'ProjectTaktPlan'? false:true"
            @click.native="handleHeaderRowClick(train, taktarea)"
            >
            <template #middle-left>
              </template>
            <template #top-center>
            </template>
            <template #bottom-center>
            </template>
          </HeaderRow>
          <HeaderPlaceholder
            v-else
            class="cursor-pointer"
            width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
            height="calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom))"
            z_index="4"
            sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
            border_color="black"
            border_width="0px 1px 1px 0px"
            style="overflow: hidden;"
            @click.native="updateUDObject({
                url: [
                  {projects: project_id},
                  {trains: train.id}
                ],
                update: {
                  closed: false
                }
              })"
            >
            <TrainHead :zoom="0.3" color="rgba(255,255,255,0.9)"/>
            <div style="margin: 0px 2px 0px 2px">{{train.taktareas.length}}</div>
            <TrainTail :zoom="0.3" color="rgba(255,255,255,0.9)"/>
          </HeaderPlaceholder>
          <Placeholder
            :id="`placeholder_trainstart_${train.id}`"
            :ref="`placeholder_trainstart_${train.id}`"
            :key="`placeholder_trainstart_${train.id}`"
            :count="train.train_start"
            :class="getMoveTrainStartVariables.move_train_start? '':'transition-all'"
            >
            <template #bottom-right>

            </template>
          </Placeholder>
          <TrainHead
            v-if="taktarea_index === 0"
            :is_taktarea="!train.closed"
            class="cursor-pointer"
            :key="`trainhead${taktarea.id}`"
            @click.native="
              toggleWaggonTransition(),
              updateUDObject({
                url: [
                  {projects: project_id},
                  {trains: train.id},
                ],
                update: {
                  closed: !train.closed
                }
              })"
          />
          <Placeholder
            v-else :count="1"
            :key="`placeholdertrainhead${taktarea.id}`"
          />
          <Placeholder
            :id="`placeholder_taktareastart_${taktarea.id}`"
            :ref="`placeholder_taktareastart_${taktarea.id}`"
            :key="`placeholder_taktareastart_${taktarea.id}`"
            :count="taktarea.taktarea_start"
            :class="getMoveTaktareaStartVariables.move_taktarea_start? '':'transition-all'"
            >
            <template #bottom-right>
            </template>
          </Placeholder>
            <TPMWaggon
              v-for="(waggon, waggon_index) in getUObjects({type: 'twaggons', ids: taktarea.twaggons})"
              :key="`waggonhoveractivtor${waggon.id}`"
              :waggon_transition="waggon_transition"
              :project_id="project_id"
              :train="train"
              :taktarea="taktarea"
              :waggon="waggon"
              :waggon_index="waggon_index"
              :new_milestone="new_milestone"
              :milestone_selection="milestone_selection"
              :snackbar="snackbar"
            />
          <template v-if="train.closed">
            <div style="display: flex">
              <TWaggon
                v-for="waggon in (getTrainLength(train.id) - getTaktareaLength(taktarea.id) - train.train_start)"
                :key="`waggonPlaceholder${taktarea.id}${waggon}`"
                :dummy="true"
              />
            </div>
          </template>
          <template v-else-if="taktarea_index === train.taktareas.length-1">
            <Placeholder :count="getTrainLength(train.id) - getTaktareaLength(taktarea.id) - train.train_start"/>
          </template>
          <TrainTail
            v-if="taktarea_index === train.taktareas.length-1 ||
              train.closed"
            :is_taktarea="!train.closed"
            />
        </template>
      </TaktArea>
    </transition>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';

  import TaktArea from '@/components/ProjectTaktPlan/TaktArea.component.vue';
  import TPMWaggon from '@/views/Project/ProjectTaktPlanMobile/TPMWaggon.wrapper.vue';
  import HeaderRow from '@/components/ProjectTaktPlan/HeaderRow.component.vue';
  import HeaderPlaceholder from '@/components/ProjectTaktPlan/HeaderPlaceholder.component.vue';
  import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue'
  import Placeholder from '@/components/ProjectTaktPlan/Placeholder.component.vue'
  import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue'
  import TWaggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
  import TaktTimeHighLighter from '@/components/ProjectTaktPlan/TaktTimeHighLighter.component.vue'
  import HeaderTrainOpen from '@/components/ProjectTaktPlan/HeaderTrainOpen.component.vue'

  export default {
    props: [
      'project_id',
      'train',
      'train_index',
      'taktarea',
      'taktarea_index',
      'draggable_disabled',
      'new_milestone',
      'milestone_selection',
      'snackbar',
    ],
    components: {
      TaktArea,
      TPMWaggon,
      HeaderRow,
      HeaderPlaceholder,
      TrainHead,
      Placeholder,
      TrainTail,
      TWaggon,
      TaktTimeHighLighter,
      HeaderTrainOpen,
    },
    data: () => ({
      waggon_transition: true,
      show_taktarea: false,
    }),
    // updated() {
    //   console.log('tptaktarea updated');
    // },
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects',
      ]),
      ...mapGetters('ProjectCalendar', [
        'getCurrentTaktIndex',
      ]),
      ...mapGetters('ProjectMilestone', [
        'getNewMilestone',
        'getMileStoneLinkType',
      ]),
      ...mapGetters('Project', [
        'getProjectLength',
        'isEditMode',
        'isInsertingTrain',
      ]),
      ...mapGetters('Train', [
        'getMoveTrainStartVariables',
        'getTrainLength',
      ]),
      ...mapGetters('TaktArea', [
        'getTaktareaLength',
        'getMoveTaktareaStartVariables',
      ]),
      ...mapGetters('View', [
          'isSpatialView'
      ]),
    },
    methods: {
      ...mapActions('Ultra', [
        'createUObject',
        'updateUObject',
        'deleteUObject',
        'updateUObjectPosition',
      ]),
      ...mapActions('UltraDev', [
        'updateUDObject',
      ]),
      ...mapActions('ProjectMilestone', [
        'editMilestoneSelection',
        'editNewMilestoneSelection',
      ]),
      ...mapActions('TaktArea', [
        'changeTaktAreaStartBulk',
        'setMoveTaktareaStartVariables',
      ]),
      ...mapActions('Train', [
        'setMoveTrainStartVariables',
      ]),
      ...mapActions('SnackBar', [
        'requestSnackbarUpdatePosition',
      ]),
      toggleWaggonTransition() {
        this.waggon_transition = false;
        let self = this;
        setTimeout(function () {
          self.waggon_transition = true;
        }, 1000);
      },
      getHeaderRowBorder(prop, value, new_milestone, color) {
        return color;
      },
      handleHeaderRowClick(train, taktarea) {
        if (this.$route.name === 'TrainMilestonesAdd' && this.getNewMilestone(this.project_id).milestone.linkType === 'selection') {
          this.editNewMilestoneSelection({
              project_id: this.project_id,
              prop: train.closed?'trains':'taktareas',
              value: train.closed?train:taktarea,
            });
        } else if (this.$route.name === 'TrainMilestonesEdit' &&
          this.getMileStoneLinkType({
            project_id: this.project_id,
            milestone_id: this.$route.params.milestone_id
          }) === 'selection') {
            this.editMilestoneSelection({
              project_id: this.project_id,
              milestone_id: this.$route.params.milestone_id,
              prop: train.closed?'trains':'taktareas',
              value: train.closed?train:taktarea,
            });
          }
      },
      getTaktareasForCreateBulk(count, start, position, direction) {
        let taktareas = [];
        for (let i = 0; i < count; i++) {
          taktareas.push({
            taktarea_start: start + direction + i,
            position: position + direction + i,
          });
        }
        return taktareas;
      },
      moveTaktareaStartMouseDown(payload) {
        this.$refs[`taktarea${payload.taktarea_id}`].$el.style.width =
          `${this.$refs[`taktarea${payload.taktarea_id}`].$el.clientWidth + window.innerWidth}px`;
        this.setMoveTaktareaStartVariables({
          initial_x: payload.evt.pageX,
          train_id: payload.train_id,
          taktarea_id: payload.taktarea_id,
          initial_width: this.$refs[`placeholder_taktareastart_${payload.taktarea_id}`].$el.clientWidth,
          move_taktarea_start: true,
        });
      },
      moveTrainStartMouseDown(payload) {
        this.$refs[`taktarea${payload.taktarea_id}`].$el.style.width =
          `${this.$refs[`taktarea${payload.taktarea_id}`].$el.clientWidth + window.innerWidth}px`;
        this.setMoveTrainStartVariables({
          initial_x: payload.evt.pageX,
          train_id: payload.train_id,
          taktarea_id: payload.taktarea_id,
          initial_width: this.$refs[`placeholder_trainstart_${payload.train_id}`].$el.clientWidth,
          move_train_start: true,
        }
      );
      },
      onintersect(entries, observer, isIntersecting) {
        // if (entries[0].target.children[7]) {
        //   if (isIntersecting === false) {
        //     entries[0].target.children[7].style.display = "none";
        //   } else {
        //     entries[0].target.children[7].style.display = "flex";
        //   }
        // }
        if (isIntersecting) {
          this.show_taktarea = true;
        } else {
          this.show_taktarea = false;
        }
      },
    }
  }
</script>
<style>
.m-taktarea-intersection-placeholder {
  height: calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom));

  /* height: 42px; */
  /* width: 100%; */
  /* background-color: green; */
}
</style>
